var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "empty-notes" }, [
    _c("p", { staticClass: "text-1" }, [_vm._v(_vm._s(_setup.text.noNotes))]),
    _c("p", { staticClass: "text-2" }, [
      _vm._v(_vm._s(_setup.text.addNotesMesage)),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }